/**
 * @module ui/focus-manager
 */
import { focusOnElement } from "utils/dom-controller";
import logger from "utils/logger";
import { toArray } from "utils/utils";

const debugTag = "[FOCUS-MANAGER]";
export const focusableSelector = "a, button, [href], input, select, textarea";

let allModalInput = null;
let firstElement = null;
let lastElement = null;

/**
 * @method trapFocus
 * @description when SHIFT or TAB is pressed, will check to see if the focus has left the current modal
 * @param {KeyboardEvent} k
 */
export function trapFocus(k) {
  const keyEvent = k || window.event;
  const KEYCODE_TAB = 9;
  const isTabPressed = (keyEvent.key === "Tab" || keyEvent.keyCode === KEYCODE_TAB);
  // if true then tabbing backwards
  const ifShiftKeyPressed = keyEvent.shiftKey;

  if (isTabPressed) {
    logger.info(`${debugTag} trapFocus()`);
    if (ifShiftKeyPressed && document.activeElement === firstElement) {
      keyEvent.preventDefault();
      setTimeout(focusOnElement.bind(this, lastElement), 0);
    } else if (!ifShiftKeyPressed && document.activeElement === lastElement) {
      keyEvent.preventDefault();
      setTimeout(focusOnElement.bind(this, firstElement), 0);
    }
  }
}

/**
 * @method bootstrapFocusElements
 * @description takes in a html element and finds the first and last focusable elements and saves a reference to them
 * @param {Object} c - collection of properties
 * @param {HTMLElement} c.targetElement
 */
export function bootstrapFocusElements({
  targetElement
}) {
  allModalInput = toArray(targetElement.querySelectorAll(focusableSelector));
  firstElement = allModalInput[0];
  lastElement = allModalInput[allModalInput.length - 1];
}

/**
 * @method getFirstFocusableElement
 * @returns {HTMLElement}
 */
export function getFirstFocusableElement() {
  return firstElement;
}

/**
 * @method getLastFocusableElement
 * @returns {HTMLElement}
 */
export function getLastFocusableElement() {
  return lastElement;
}

/**
 * @method toggleBgAccess
 * @description toggles on trapping for all inputs in pb-root element.
 *  If the user tabs on to a background element, the user's focus will be redirected to the modal.
 * @param {Boolean} turnOn
 */
export function toggleBgAccess(turnOn) {
  logger.info(`${debugTag} toggleBgAccess() | turnOn:`, turnOn);

  if (turnOn) {
    document.addEventListener("keydown", trapFocus);
  } else {
    document.removeEventListener("keydown", trapFocus);
  }
}
